// test1699
(1699 && 0);
